// Core
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { 
	Flex, 
	Button, 
	Box, 
	Image, 
	Grid, 
	Text, 
	Select,
	Spinner, 
	useDisclosure
} from '@chakra-ui/react';
import { Route, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';

// Assets
import { apiService } from 'services/ApiService';
import { textLang } from 'services/Lang';
import logo from 'assets/img/logo.png';
import glow from 'assets/img/1.png';

// Components
import Card from 'components/Card/Card';
import ErrorCard from 'components/Form/Errors';

const SignUp = () => {
	const currentYear = new Date().getFullYear();

	const [isLoading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);

	const history = useHistory();
	const handleLogin = async () => {
		setIsLoading(true);
		setIsError();

		const webApp = window.Telegram.WebApp;
	    webApp.ready();

	    const initData = webApp.initData;
		console.log('initData:', initData); // Логируем initData

		if (!initData) {
		    setIsError('Telegram initData is missing');
		    setIsLoading(false);

		    //handleSignUp();
			setIsLoading(false);
		    return;
		}

		try {
			const response = await apiService.checklogin({initData});
			if(response.statusCode === 200){
				if(response?.data?.accessToken){
		          localStorage.setItem('auth', JSON.stringify(response.data));
		        }
		        history.push('/'); 
		        setIsLoading(false);
		        return;
			}
		} catch(e) {
			//handleSignUp();
			//setIsLoading(false);	
		}

		handleSignUp();
		setIsLoading(false);
	};

	const handleSignUp = async () => {
		setIsLoading(true);
		setIsError();

		const webApp = window.Telegram.WebApp;
	    webApp.ready();

	    const initData = webApp.initData;
		console.log('initData:', initData); // Логируем initData

		if (!initData) {
		    setIsError(textLang('initData'));
		    setIsLoading(false);
		    return;
		}

		try {
			const response = await apiService.login({initData});
			if(response.statusCode === 200 || response.statusCode === 201){
				if(response?.data?.accessToken){
		          localStorage.setItem('auth', JSON.stringify(response.data));
		        }

		        history.push('/profile'); 

		        setIsLoading(false);
			} else if (response.statusCode === 401 || response.statusCode === 400){
				setIsLoading(false);
				setIsError(response.message);
			}

			setIsLoading(false);
			setIsError(response.statusCode);
		} catch(e) {
			setIsLoading(false);
			setIsError(e);
		}

		//console.log(object);
		//localStorage.setItem('auth', JSON.stringify(object)); 
	    //history.push('/profile'); 
	};

	const [editMode, setEditMode] = useState(true);

	const currentLang = localStorage.getItem('lang') || 'en';

	const handleChange = (e) => {
    const lang = e.target.value;
    localStorage.setItem('lang', lang);
    window.location.href = '/';
  };

	return (
		<Box w="100%" position="relative" textAlign="center">
				<>
					<Select
						w="200px"
						className="change-lang"
						m="0 auto 12px auto"
			      defaultValue={currentLang}
			      onChange={handleChange}
			    >
			      <option value="en">English 🇬🇧</option>
			      <option value="ru">Русский 🇷🇺</option>
					</Select>

					<Image src={logo} maxW="380px" m="0 auto" w="100%" />

					<Text m="0px auto 0 auto" maxW="80%" variant="title-lg">
						{textLang('auth_hello_header')}
					</Text>

					<Text m="8px auto 24px auto" maxW="90%" variant="text-sm">
						{textLang('auth_hello_sub')}
					</Text>

					<Image src={glow} m="0 auto" maxW="280px" m="0 auto" w="100%"  />

					<Box px="10%" mt="24px">
			      <Button
			        variant="button-lg"
			        isLoading={isLoading}
			        onClick={handleLogin}
			      >
			        {textLang('auth_hello_next_button')}
			      </Button>

			      { isError && <ErrorCard error={isError} mt="24px" /> }
				</Box>

				<Box maxW="90%" m="32px auto 0 auto">
				<Text variant="text-xs">🚀 {currentYear} seventgram KLKILabs – Making Connections That Matter.</Text>
				<Text variant="text-xs">Powered by KLKILabs.org</Text>
				<Text variant="text-xs">All rights reserved.</Text>
			</Box>
		  </>
		</Box>
	);
};

export default SignUp;